import { render } from "./homeView.vue?vue&type=template&id=520f9cac&scoped=true"
import script from "./homeView.vue?vue&type=script&lang=js"
export * from "./homeView.vue?vue&type=script&lang=js"

import "./homeView.vue?vue&type=style&index=0&id=520f9cac&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-520f9cac"]])

export default __exports__